// extracted by mini-css-extract-plugin
export default {"container":"TextAreaResizable_container__m4n1w","counter":"TextAreaResizable_counter__07YLM"};